// extracted by mini-css-extract-plugin
export default {"loginSuccessBody":"LoginSuccess_loginSuccessBody__QTVC8"};